angular.module("vgresiduos").directive("disposalManifest", function () {
	return {
		scope: true,
		controller: "DisposalManifestCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/steps/disposalManifest/disposalManifest_template.html"
	};
});
